import { AnyComponentOption, MeasureChartComponentData, ImageComponentData, TextComponentData, ComponentConfigOption, IndexComponentData, GanttComponentData } from "@core/data/types/advanced-report";
import { TableComponentData } from "@core/data/types/Reports/report-tables";
import { GridsterItem } from "angular-gridster2";

export class InitComponentState {
    static readonly type = '[ComponentState] Init ComponentState';
    constructor (public key: string, public reportKey: string, public shareKey: string = null) {}
}

export class UpdateReportComponent {
    static readonly type = '[ComponentState] Update Component';
    constructor (public key: string, public item: Partial<GridsterItem>) {}
}

export class LoadComponentOptions {
    static readonly type = '[ComponentState] Load Component Options';
    constructor (public componentKey: string) {}
}

export class EditComponentOptions {
    static readonly type = '[ComponentState] Edit Component Options';
    constructor (
        public componentKey: string,
        public data: TextComponentData | ImageComponentData | MeasureChartComponentData | IndexComponentData | TableComponentData | GanttComponentData,
        public key?: string,
        public config?: ComponentConfigOption
    ) {}
}

export class EditComponentConfigOptions {
    static readonly type = '[ComponentState] Edit Config Options';
    constructor (public componentKey: string, public config: ComponentConfigOption) {}
}

export class DeleteReportComponent {
    static readonly type = '[ComponentState] Delete Component';
    constructor (public key: string, public pageKey: string, public showMessage: boolean = true) {}
}